import Image from "next/image";
import { cn } from "@/app/lib/utils";

interface LogoProps {
  /** Size in pixels - defaults to 40 */
  size?: number;
  /** Optional additional classes */
  className?: string;
  /** Whether to show the border - defaults to true */
  showBorder?: boolean;
  /** Whether to show the glow effect - defaults to false */
  showGlow?: boolean;
}

export function Logo({
  size = 40,
  className,
  showBorder = true,
  showGlow = false,
}: LogoProps) {
  // Calculate the inner image size to account for padding and border
  const innerSize = showBorder ? size - 4 : size; // Subtract padding (2px * 2)

  return (
    <div
      className={cn(
        "relative inline-block rounded-full bg-transparent",
        showBorder && "p-[2px]",
        showGlow &&
          "before:absolute before:inset-0 before:rounded-full before:bg-gradient-to-r before:from-primary/20 before:via-accent/20 before:to-primary/20 before:blur-sm before:opacity-50",
        className
      )}
      style={{ width: size, height: size }}
    >
      <div
        className={cn(
          "relative overflow-hidden rounded-full w-full h-full flex items-center justify-center",
          showBorder && "ring-2 ring-accent"
        )}
      >
        <Image
          src="/logo.jpeg"
          alt="SpinDoctor Logo"
          width={innerSize}
          height={innerSize}
          className="object-cover w-full h-full"
          priority
        />
      </div>
    </div>
  );
}
